import { useCurrentUser } from "./useCurrentUser";

export function useCurrentUserLocale() {
  return useCurrentUser()?.locale;
}
